module.exports = __webpack_public_path__ + "./docs/img/icon-interface.1e5d0bf8f8f901f33bdf279ce54a1425.svg";